<template>
    <div>
        <div class="water-bg"
        :style="{ backgroundImage:`url(${getWaterMarkStatus})` }">
        </div>
        <Tabs type="card" :animated="false" @on-click="tabClick">
            <TabPane :label="$t('Employee_Information')" name="BasicInformation"><BasicInformation ref="BasicInformation"></BasicInformation></TabPane><!-- 基本信息 -->
            <!-- <TabPane :label="$t('Human_Resource_Data')" name="PersonnelInformation"><PersonnelInformation ref="PersonnelInformation"></PersonnelInformation></TabPane>人事信息 -->
            <TabPane :label="$t('Department_Level')" name="DepartmentLevel"><DepartmentLevel ref="DepartmentLevel"></DepartmentLevel></TabPane><!-- 部门层级 -->
            <TabPane :label="$t('Position_Info')" name="PositionInformation"><PositionInformation ref="PositionInformation"></PositionInformation></TabPane><!-- 职位信息 -->
            <!--<TabPane :label="$t('Contract_List')" name="ContractList"><ContractList ref="ContractList"></ContractList></TabPane> 合同列表 -->
            <TabPane :label="$t('Social_Relationships')" name="SocialRelations"><SocialRelations ref="SocialRelations"></SocialRelations></TabPane><!-- 社会关系 -->

            <TabPane :label="$t('Work_Experience')" name="WorkExperience"><WorkExperience ref="WorkExperience"></WorkExperience></TabPane><!-- 工作经验 -->
            <TabPane :label="$t('Education_Background')" name="EducationBackground"><EducationBackground ref="EducationBackground"></EducationBackground></TabPane><!-- 教育背景 -->
            <TabPane :label="$t('Skill_Information')" name="SkillInformation"><SkillInformation ref="SkillInformation"></SkillInformation></TabPane> <!--技能信息 -->

            <!-- <TabPane :label="$t('Apply_Training_Record')" name="TrainingRecord"><TrainingRecord ref="TrainingRecord"></TrainingRecord></TabPane>培训记录-->
            <!-- <TabPane :label="$t('Welfare_Information')" name="BenefitInformation"><BenefitInformation ref="BenefitInformation"></BenefitInformation></TabPane>福利信息 -->
            <TabPane :label="$t('Evaluation_Record')" name="EvaluationRecord"><EvaluationRecord ref="EvaluationRecord"></EvaluationRecord></TabPane><!-- 评估记录 -->
            <TabPane :label="$t('Career_Development')" name="CareerDevelopment"><CareerDevelopment ref="CareerDevelopment"></CareerDevelopment></TabPane><!-- 职业发展 -->
        </Tabs>
    </div>
</template>

<script>
import addWaterMark from "@/util/watermark"
import BasicInformation from './components/BasicInformation.vue'
import PersonnelInformation from './components/PersonnelInformation.vue'
import DepartmentLevel from './components/DepartmentLevel.vue'
import PositionInformation from './components/PositionInformation.vue'
import ContractList from './components/ContractList.vue'
import SocialRelations from './components/SocialRelations.vue'

import WorkExperience from './components/WorkExperience.vue'
import EducationBackground from './components/EducationBackground.vue'
import SkillInformation from './components/SkillInformation.vue'

import TrainingRecord from './components/TrainingRecord.vue'
import BenefitInformation from './components/BenefitInformation.vue'
import EvaluationRecord from './components/EvaluationRecord.vue'
import CareerDevelopment from './components/CareerDevelopment.vue'
export default {
    components:{
        BasicInformation,
        PersonnelInformation,
        DepartmentLevel,
        PositionInformation,
        ContractList,
        SocialRelations,
        WorkExperience,
        EducationBackground,
        SkillInformation,
        TrainingRecord,
        BenefitInformation,
        EvaluationRecord,
        CareerDevelopment
    },
    data(){
        return{

        }
    },
    computed:{
        getWaterMarkStatus(){
             return addWaterMark("zh-CN");
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.$refs.BasicInformation.getData()
        })
    },
    methods:{
        tabClick(val){
            this.$refs[val].getData()
        }
    }
}

</script>
<style lang="less" scoped>

    .water-bg {
    
    position: absolute;
    
    top: 0;
    
    
    height: 100%;
    
    width: 100%;
    
    z-index: 999999;
    
    pointer-events: none;
    }
    </style>




// WEBPACK FOOTER //
// src/components/process/files/CarlsbergPersonFiles.vue